module.exports = __webpack_public_path__ + "static/sofiapro-100-b957359da92dced21ed6b4bbc1f4cdcb.woff";